<template>
  <v-select
          @change="$emit('on:template-selected', original)"
          v-model="original"
          :items="items"
          :label="label"
          :rules="rules"
          :required="required"
          item-text="name"
          return-object
  ></v-select>
</template>

<script>
export default {
  name: 'TemplateSelector',
  props: {
    label: {},
    items: {},
    rules: {
      type: Array,
      default: () => [],
    },
    required: { default: () => false },
  },
  data: () => ({ original: {} }),
};
</script>
